import i18n from '@/locale'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'
import store from '@/store'
import { maxTabs } from '@/config'
import { resolveAppHomePath } from '@/utils/resolveAppHomePath'

Vue.use(VueRouter)
export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    // 权限未加载前 resolveAppHomePath 为 null，暂落 /cashier；permission 守卫会再按收银/首菜单纠正
    redirect: () => resolveAppHomePath(store) || '/cashier',
    meta: { hidden: true },
  },
  {
    path: '/payPanel',
    name: 'payPanel',
    hidden: true,
    meta: { hidden: true, title: i18n.t('返回') },
    component: () => import('@/views/payPanel/index.vue'),
  },
  {
    path: '/newPayPanel',
    name: 'newPayPanel',
    hidden: true,
    meta: { hidden: true, title: i18n.t('返回') },
    component: () => import('@/views/newPayPanel/index.vue'),
  },
  {
    path: '/searchMember',
    component: Layout,
    hidden: true,
    meta: { hidden: true },
    children: [
      {
        path: '/searchMember',
        name: 'searchMember',
        component: () => import('@/views/member/searchMember/index.vue'),
        meta: { hidden: true, title: i18n.t('搜索会员') },
      },
    ],
  },
  {
    path: '/hangOrder/:type',
    name: 'hangOrder',
    hidden: true,
    redirect: '/hangOrder/:type',
    meta: { hidden: true },
    component: Layout,
    children: [
      {
        path: '/hangOrder/:type',
        name: 'hangOrder',
        component: () => import('@/views/order/hangOrder/index.vue'),
        meta: { title: i18n.t('挂单') },
      },
    ],
  },
  {
    path: '/noticeList',
    hidden: true,
    meta: { hidden: true },
    component: Layout,
    children: [
      {
        path: '/noticeList/:type',
        name: 'noticeList',
        component: () => import('@/views/noticeContainer/noticeList'),
        hidden: true,
        meta: {
          name: 'noticeList',
          title: i18n.t('通知列表'),
        },
      },
      {
        path: '/notice/noticeDetails/:id',
        name: 'noticeDetails',
        component: () => import('@/views/noticeContainer/noticeDetails'),
        hidden: true,
        meta: {
          name: 'noticeDetails',
          title: i18n.t('通知详情'),
        },
      },
    ],
  },
  // {
  //   path: '/fund/account/detail',
  //   name: 'AccountBalanceDetail',
  //   hidden: true,
  //   meta: { hidden: true, title: i18n.t('账户流水明细') },
  //   component: Layout,
  //   children: [
  //     {
  //       path: '/fund/account/detail',
  //       name: 'AccountBalanceDetail',
  //       component: () => import('@/views/fund/account/detail.vue'),
  //       meta: {
  //         title: i18n.t('账户流水明细'),
  //         keepAlive: true,
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: '/fund/account/init',
  //   name: 'AccountBalanceInit',
  //   hidden: true,
  //   meta: { hidden: true, title: i18n.t('期初设置') },
  //   component: Layout,
  //   children: [
  //     {
  //       path: '/fund/account/init',
  //       name: 'AccountBalanceInit',
  //       component: () => import('@/views/fund/account/init.vue'),
  //       meta: {
  //         title: i18n.t('期初设置'),
  //         keepAlive: true,
  //       },
  //     },
  //   ],
  // },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: { title: i18n.t('登录'), hidden: true },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue'),
    meta: { title: '404', hidden: true },
  },
  {
    path: '/401',
    name: '401',
    component: () => import('@/views/401.vue'),
    meta: { title: '401', hidden: true },
  },
  {
    path: '/handover',
    name: 'Handover',
    component: () => import('@/views/Handover.vue'),
    meta: { title: i18n.t('交接班'), hidden: true },
  },
   {
    path: '/cashier/oftenitems',
    name: 'OftenItems',
    component: () => import('@/views/cashier/oftenitems.vue'),
    meta: { title: '', hidden: true },
  },
  {
    path: '/newCashier/oftenitems',
    name: 'NewOftenItems',
    component: () => import('@/views/newCashier/oftenitems.vue'),
    meta: { title: '', hidden: true },
  },
  {
    path: '/takeaway/setting/sync-good',
    name: 'TakeawaySyncGood',
    component: () => import('@/views/takeaway/setting/sync_good.vue'),
    meta: { title: i18n.t('商品匹配关系'), hidden: true },
  },
]

// 开发环境下，添加一些本地用于模拟测试的路由
// if (process.env.NODE_ENV === 'development') {
//   const mockRoutes = require('../../test/routes.js').default
//   constantRoutes.push(...mockRoutes)
// }

function createRouter() {
  return new VueRouter({
    mode: 'history',
    routes: constantRoutes,
  })
}
const router = createRouter()

const CHUNK_RELOAD_FLAG = window.__CHUNK_RELOAD_FLAG_KEY__ || 'chunk_reload_once'
const chunkLoadErrorPattern = /ChunkLoadError|Loading chunk [\d]+ failed|Loading CSS chunk [\d]+ failed|Failed to fetch dynamically imported module/i

/**
 * 检测是否为动态分包加载失败
 * @param {*} error
 * @returns {boolean}
 */
function isChunkLoadError(error) {
  const message = error?.message || ''
  return error?.name === 'ChunkLoadError' || chunkLoadErrorPattern.test(message)
}

/**
 * chunk 加载失败时，自动刷新一次并防止死循环
 * @param {*} error
 * @returns {boolean}
 */
function handleChunkLoadError(error) {
  if (!isChunkLoadError(error)) return false

  const hasReloaded = sessionStorage.getItem(CHUNK_RELOAD_FLAG) === '1'
  if (!hasReloaded) {
    sessionStorage.setItem(CHUNK_RELOAD_FLAG, '1')
    const nextUrl = new URL(window.location.href)
    nextUrl.searchParams.set('_chunk_reload_ts', `${Date.now()}`)
    window.location.replace(nextUrl.toString())
    return true
  }
  const mgMessage = Vue.prototype?.$mgMessage
  if (typeof mgMessage === 'function') {
    mgMessage(i18n.t('系统已更新，请强制刷新页面后重试'), 'warning')
  } else {
    console.warn('TIPS 系统已更新，请强制刷新页面后重试')
  }
  return true
}

export function resetRouter() {
  router.matcher = createRouter().matcher
}

const originalPush = router.push
router.push = function (...args) {
  const location = this.match(args[0])
  const visiteRoutes = store.getters['tabsBar/visiteRoutes']
  const target = visiteRoutes.find((item) => item.path === location.path)
  if (!target && visiteRoutes?.length > maxTabs) {
    const message = i18n.t('最多只能打开{slot1}个页面，请先关闭部分页面。是否关闭前五个页面？', { slot1: maxTabs + 1 })
    Vue.prototype
      .$mgAlert(message, i18n.t('提示'), { confirmButtonText: i18n.t('关闭并打开新页面') })
      .then(() => {
        const changePages = store.getters['tabsBar/changePages']
        if (visiteRoutes.some((item) => changePages.includes(item?.name))) {
          return Vue.prototype.$mgConfirm(i18n.t('当前页面正在编辑，确认关闭?'))
        }
      })
      .then(() => {
        visiteRoutes.slice(1, 5).forEach((route) => store.dispatch('tabsBar/removeTab', route))
        originalPush.call(this, ...args)?.catch(() => {})
      })
    return
  }
  return originalPush.call(this, ...args)?.catch(() => {})
}

router.onError((error) => {
  if (handleChunkLoadError(error)) return
  console.error('TIPS 路由异常:', error)
})

router.afterEach(() => {
  sessionStorage.removeItem(CHUNK_RELOAD_FLAG)
})

export default router
